import { Routes, Route, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppLogin from './login/AppLogin';
import AppProviderDesktop from './desktop/AppProviderDesktop';
import './app.css';


const App = () => {

    const navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState(false)
    
    useEffect(() => {

        const checkAuth = () => {
            const token = sessionStorage.getItem('token');
            if (token) {
                setIsAuthenticated(true);
            } else {
                setIsAuthenticated(false);
                navigate('/login');
            }
        };

        checkAuth();

        const storageChange = () => {
            checkAuth();
        }

        window.addEventListener('storage', storageChange);

        return () => {
            window.removeEventListener('storage', storageChange);
        }

    }, [navigate])

    return (
        <Routes>
            {isAuthenticated ? 
                <>
                    <Route path='/' element={<AppProviderDesktop navigate={navigate} />} />
                    <Route path='*' element={<Navigate to="/" />} />
                </>
            :
                <>
                    <Route path='/login' element={<AppLogin />} />
                    <Route path='*' element={<Navigate to="/login" />} />
                </>
            }
        </Routes>
    );
}

export default App;